<template>
  <div>
    <div class="background-color-white mt-8 pl-8">
      <VCDataTable v-bind="dtable" ref="dataTable">
        <template v-slot:table_col_sn="scope">
          <div class="right">
            <el-tooltip class="item" effect="dark" :content="scope.row.sn" placement="right" style="cursor: pointer">
              <span class="svg-icon svg-icon-muted svg-icon-2hx copybox" :data-clipboard-text="scope.row.sn" @click="eCopySn">
                <svg width="20" height="20" color="#cfcfd4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect opacity="0.5" x="7" y="2" width="14" height="16" rx="3" fill="currentColor" />
                  <rect x="3" y="6" width="14" height="16" rx="3" fill="currentColor" />
                </svg>
              </span>
            </el-tooltip>
          </div>
        </template>
        <template v-slot:table_col_sourceUrl="scope">
          <el-tooltip class="tooltip-box-item" effect="dark" placement="top-start" v-if="scope.row.sourceUrl">
            <template #content>
              <div style="max-width: 670px">
                {{ scope.row.sourceUrl }}
              </div>
            </template>
            <div class="table_ellipsis">
              {{ scope.row.sourceUrl }}
            </div>
          </el-tooltip>
        </template>
        <template v-slot:table_col_record="scope">
          <el-tooltip class="tooltip-box-item" effect="dark" placement="top-start" v-if="scope.row.record && scope.row.status !== 'Success'">
            <template #content>
              <div style="max-width: 670px">
                {{ eGetGetRecord(scope.row) }}
              </div>
            </template>
            <div class="table_ellipsis_memo">
              {{ scope.row.record }}
            </div>
          </el-tooltip>
          <div class="table_ellipsis_memo" v-else></div>
        </template>
        <template #search-append>
          <div>
            <div class="h5 font-weight-boldest pb-5">日志查看</div>
            <div class="d-flex">
              <div class="d-flex pr-4 align-items-center">
                <span>SN：</span>
                <el-input v-model="keyword" placeholder="输入SN或任务ID搜索.."></el-input>
              </div>
              <div class="d-flex align-items-center pb-3">
                <span>状态：</span>
                <div style="width: 80px">
                  <vi-selector v-model="status" :options="statusList"> </vi-selector>
                </div>
              </div>
              <div class="d-flex align-items-center ml-3">
                <span>时间范围：</span>
                <el-date-picker v-model="time" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" style="width: 400px"> </el-date-picker>
              </div>
              <div class="d-flex align-items-center ml-3">
                <div style="width: 150px">
                  <button type="reset" class="btn btn-primary" @click="eFilter">查看</button>
                </div>
              </div>
            </div>
          </div>
        </template>
      </VCDataTable>
    </div>
    <div class="background-color-white p-8 mt-8" v-loading="dayLoading">
      <span class="h5 font-weight-boldest"> 失败数据原因分析（TOP 15）</span>
      <div class="d-flex pb-8 mt-5">
        <div class="d-flex align-items-center">
          <span>时间范围：</span>
          <div>
            <el-date-picker :clearable="false" v-model="errorTime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" style="width: 400px"> </el-date-picker>
          </div>
        </div>
        <div class="d-flex align-items-center ml-3">
          <div>
            <button type="reset" class="btn btn-primary" @click="Column">查看</button>
          </div>
        </div>
      </div>
      <div id="c1"></div>
    </div>
  </div>
</template>
<script>
import VCDataTable from "@leiweb/kernel-dashboard/src/controls/data/DataTable";
import Clipboard from "clipboard";
import { Bar } from "@antv/g2plot";
import enumErrorType from "@/utils/productErrorType";
var moment = require("moment");
export default {
  name: "Logs",
  components: {
    VCDataTable,
  },
  props: {
    userSN: String,
  },
  data() {
    return {
      dtable: {
        url: "/shiyun/marketing/apis/biz/console/product/ocr/normal/task/page",
        orderBy: { name: "Time", type: "Desc" },
        params: [`userSN == ${this.userSN}`, `time >= ${moment(new Date().setDate(1)).startOf("day").format("x")}`, `time <= ${moment(new Date().getTime()).endOf("day").format("x")}`],
        search: {
          hidden: true,
        },
        fields: [
          {
            name: "sn",
            source: "sn",
            type: "slot",
            label: "sn",
            // table: { hidden: true },
          },
          {
            name: "time",
            type: "date",
            format: "YYYY-MM-DD",
            label: "日期",
          },
          {
            name: "sourceUrl",
            source: "sourceUrl",
            type: "slot",
            label: "文件链接",
          },
          {
            name: "status",
            type: "select",
            label: "状态",
            options: [
              { value: "Success", label: "成功" },
              { value: "Fail", label: "失败" },
            ],
          },
          { name: "record", type: "slot", label: "备注" },
        ],
        add: {
          enable: false,
        },
        edit: {
          enable: false,
        },
        rowActions: [],
      },
      status: "all",
      errorTime: [moment().subtract(29, "days"), moment().endOf("day")],
      statusList: [
        { value: "all", label: "全部" },
        { value: "Success", label: "成功" },
        { value: "Fail", label: "失败" },
      ],

      time: "",
      keyword: "",
      dayLoading: false,
      barPlot: null,
    };
  },
  activated() {
    // console.log(" this.status1   ----->  ", this.status);
    // this.status = this.optionStatus;
    // console.log(" this.status2   ----->  ", this.status);
    if (this.todayTime) {
      this.time = [moment(this.todayTime[0]).startOf("day"), moment(this.todayTime[1]).endOf("day")];
      this.errorTime = [moment(this.todayTime[0]).startOf("day"), moment(this.todayTime[1]).endOf("day")];
    }
    // this.eFilter();
    // this.Column();
  },

  watch: {
    userSN: {
      handler() {
        this.eFilter();
        this.Column();
      },
      deep: true,
    },
  },

  mounted() {
    this.eGetTime();
  },
  methods: {
    eGetGetRecord(row) {
      return JSON.stringify(row.record);
    },
    eGetTime() {
      let fristDate = new Date().setDate(1);
      let currentDate = new Date().getTime();
      this.time = [fristDate, currentDate];
    },
    eFilter() {
      this.dtable.params = [`userSN == ${this.userSN}`];
      if (this.status && this.status != "all") {
        this.dtable.params.push(`status == ${this.status}`);
      }
      // 包含- 就是用sn查找 反之
      if (this.keyword && this.keyword.includes("-")) {
        this.dtable.params.push(`sn == ${this.keyword}`);
      } else if (this.keyword) {
        this.dtable.params.push(`ID == ${this.keyword}`);
      }
      if (this.time && this.time.length > 0) {
        this.dtable.params.push(`time >= ${moment(this.time[0]).startOf("day").format("x")}`);
        this.dtable.params.push(`time <= ${moment(this.time[1]).endOf("day").format("x")}`);
      }
    },

    eCopySn() {
      var clipboard = new Clipboard(".copybox");
      clipboard.on("success", (e) => {
        this.$message.success("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        this.$message.warning("该浏览器不支持自动复制");
        // 释放内存
        clipboard.destroy();
      });
    },

    Column() {
      this.dayLoading = true;
      if (this.barPlot != null && this.barPlot) {
        this.barPlot.destroy(); // 释放内存
      }

      let data = [];
      let args = {
        //  OcrNormal = 1, 图像识别,,VoiceRecognition = 2, 语音识别
        ProductType: 1, //产品类型
        StartTime: moment(this.errorTime[0]).startOf("day").format("x"),
        EndTime: moment(this.errorTime[1]).endOf("day").format("x"),
        // UserSN: this.userSN, //用户SN
      };
      if (this.userSN && this.userSN != "SN-0") {
        args.userSN = this.userSN;
      }
      this.$$.api
        .post("/shiyun/marketing/apis/biz/console/product/error/detail/list", args)
        .then((res) => {
          if (res.success) {
            if (res.data.list) {
              res.data.list.forEach((p) => {
                p.count = parseInt(p.count);
                p.errorType = enumErrorType[p.errorType];
              });

              data = res.data.list.slice(0, 15);
              const brandColor = "#5B8FF9";
              this.barPlot = new Bar("c1", {
                data,
                xField: "count",
                yField: "errorType",
                yAxis: {
                  label: {
                    formatter(errorType) {
                      return errorType.length > 5 ? `${errorType.slice(0, 5)}...` : errorType;
                    },
                  },
                },
                height: 200,
                tooltip: {
                  customContent: (value, items) => {
                    return `<div>
                            <div>${items?.[0]?.data.errorType}</div>
                            <li class="g2-tooltip-list-item">
                                <span class="g2-tooltip-marker" style="background-color:#7BD4E0;width:0px;height:0px;border-radius:50%;display:inline-block;margin-right:8px;"></span>
                             <span >${items?.[0]?.data.count}次</span>
                            </li>
                         </div>`;
                  },
                  domStyles: {
                    "g2-tooltip": {
                      paddingTop: "12px",
                    },
                  },
                },
                color: ({ errorType }) => {
                  if (errorType) {
                    return brandColor;
                  }
                },
              });
              this.barPlot.render(); // 渲染图表
            }
          }
        })
        .catch((err) => {
          this.$$.toastr.error(err.message);
        })
        .finally(() => {
          this.dayLoading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.background-color-white {
  background-color: #ffffff;
  border-radius: 5px 5px 5px 5px;
  padding: 20px;
  padding-top: 7px;
}

.bill_select {
  display: flex;
  flex-wrap: wrap;
}

.select_width {
  width: 170px;
}

.date_width {
  width: 200px;
}
.table_ellipsis {
  max-width: 500px;
  white-space: nowrap;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
}

.table_ellipsis_memo {
  width: 500px;
  white-space: nowrap;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
